import * as React from "react";
import { Event } from "../../../../../contracts";
import { renderStartsIn } from "./renderStartsIn";
import { BaseDict } from "../../../dict";

export const renderKickOffState = (event: Event, componentPrefix: string, dict: BaseDict) =>
    <div className={`rj-ev-list__${componentPrefix}__section-item rj-ev-list__${componentPrefix}__times`} data-uat={`div-ev-list-${componentPrefix}-times`}>
        {renderStartsIn(dict.StartsIn, event.kickOffTime ? dict.ClockMins.format(event.kickOffTime) : "")}
    </div>